import React, { FC, useState, useEffect } from 'react'
import 'react-phone-number-input/style.css'
import { Box, Typography } from '@mui/material'
import {
  BaseLayout,
  Module,
  ModuleHeader,
  ModuleBody,
  ButtonContainer,
  CustomButton,
  Loader,
} from '../../components'
import useStyles from '../enroll/enroll-styles'
import { useNavigate } from 'react-router-dom'
import { useOktaAuth } from '@okta/okta-react'
import { api, routes } from 'config'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'

import { processErrorMsg, CountryChangeMode } from 'utils'
import Axios from 'axios'
let executeOnce = true
let derivedNumber = ''
const UpdateEnrollment: FC = () => {
  const atString = localStorage.getItem('okta-token-storage') as string
  let accessToken = ''
  if (atString) {
    accessToken = JSON.parse(atString).accessToken.accessToken
    localStorage.setItem('accessToken', accessToken)
  }

  const { classes } = useStyles()
  const navigate = useNavigate()
  const { oktaAuth } = useOktaAuth()
  const [transaction, setTransaction] = useState<any | {}>({})
  const [showLoader, setShowLoader] = useState(false)
  const [serviceError, setServiceError] = useState('')
  const [isNumberValid, setIsNumberValid] = useState<boolean>(false)
  const [phoneNumber, setPhoneNumber] = useState<any>('')
  const [country, setCountry] = useState<any>('US')
  const [phoneInputFocus, setPhoneInputFocus] = useState(false)
  const [countryChangeMode, setCountryChangeMode] = useState<CountryChangeMode>(
    CountryChangeMode.AUTOMATICALLY,
  )
  // clears the input field if user selects another flag
  useEffect(() => {
    if (executeOnce) {
      derivedNumber = localStorage.getItem('mobileNumber') ?? ''
      setPhoneNumber(derivedNumber)
      setTimeout(() => {
        executeOnce = false
      }, 2000)
    }
  }, [])

  useEffect(() => {
    if (!executeOnce && countryChangeMode === CountryChangeMode.MANUALLY) {
      setPhoneNumber('')
    }
  }, [country, countryChangeMode])

  const validatePhoneNumberInternally = (
    country: string,
    phoneNumber: string,
  ) => {
    if (derivedNumber && derivedNumber === phoneNumber) {
      setIsNumberValid(false)
    } else if (country === 'US' || country === 'CA') {
      phoneNumber?.length === 12
        ? setIsNumberValid(true)
        : setIsNumberValid(false)
    } else if (country === 'IN') {
      phoneNumber?.length === 13
        ? setIsNumberValid(true)
        : setIsNumberValid(false)
    } else {
      if (phoneNumber) {
        setIsNumberValid(isValidPhoneNumber(phoneNumber))
      } else {
        setIsNumberValid(false)
      }
    }
  }

  useEffect(() => {
    validatePhoneNumberInternally(country, phoneNumber)
  }, [phoneNumber, country])

  if (transaction.sessionToken) {
    oktaAuth.signInWithRedirect({
      sessionToken: transaction.sessionToken,
    })
    return null
  }

  const handleClick = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    type: string,
  ): Promise<void> => {
    e.preventDefault()
    if (type === 'continue') {
      setServiceError('')
      setShowLoader(true)
      await Axios.post(api.updateFactorDetails(), {
        accessToken,
        phoneNumber,
        factorId: 'notRequired',
      })
        .then((response: any) => {
          setShowLoader(false)
          setTransaction(response?.data)
          navigate(routes.updateEnrollmentOtpForm, {
            state: {
              transaction: response?.data?.data,
              phoneNumber: phoneNumber,
            },
          })
        })
        .catch(() => {
          setShowLoader(false)
          setServiceError(
            processErrorMsg(
              e,
              'Update Factor Details',
              'Unable to update Phone Number for SMS factor',
            ),
          )
        })
    } else {
      navigate(routes.login)
    }
  }

  return (
    <BaseLayout maxWidth="38em">
      <Loader visible={showLoader} />
      <Module isModuleInitialized={true} serviceError={serviceError}>
        {!showLoader && (
          <>
            <ModuleHeader
              title="Two-Factor Authentication"
              isNewLayout
              className={classes.title}
            >
              <Typography variant="body1" className={classes.description}>
                Bright has added an extra layer of security to ensure only you
                can access the information you save in the MLS.
                <br />
                <br />
                To complete this process, please add your mobile number and
                click continue.
              </Typography>
              <br />
            </ModuleHeader>

            <ModuleBody isNewLayout>
              <Box className={classes.numberInput}>
                <Typography className={classes.learnMoreLink} variant="body2">
                  Mobile Number
                </Typography>
                <PhoneInput
                  placeholder="Enter phone number"
                  initialValueFormat="national"
                  defaultCountry={country}
                  value={phoneNumber}
                  onChange={(value) => {
                    setPhoneInputFocus(true)
                    setPhoneNumber(value)
                  }}
                  onCountryChange={(value) => {
                    setCountryChangeMode(
                      phoneInputFocus
                        ? CountryChangeMode.AUTOMATICALLY
                        : CountryChangeMode.MANUALLY,
                    )
                    setCountry(value)
                  }}
                  onBlur={() => {
                    setPhoneInputFocus(false)
                  }}
                />
              </Box>
              <br />
              <ButtonContainer
                primary={
                  <CustomButton
                    onClick={(e) => handleClick(e, 'continue')}
                    disabled={!isNumberValid}
                    type="submit"
                  >
                    Continue
                  </CustomButton>
                }
                secondary={
                  <CustomButton
                    onClick={(e) => handleClick(e, 'back')}
                    type="submit"
                  >
                    Back
                  </CustomButton>
                }
              />
            </ModuleBody>
          </>
        )}
      </Module>
    </BaseLayout>
  )
}

export default UpdateEnrollment
